"use client";

import { usePathname } from "next/navigation";
import { useMemo } from "react";
import cx from "classnames";
import Tick from "../../../assets/Tick.svg";

export const OnboardingMenu = () => {
  const pathname = usePathname();

  const steps = useMemo(
    () => [
      { id: 0, label: "Info", slug: "/coop/onboarding/1" },
      {
        id: 1,
        label: "Confirmation",
        slug: "/coop/onboarding/2"
      },
      {
        id: 2,
        label: "Agreement",
        slug: "/coop/onboarding/3"
      },
      { id: 3, label: "Approval", slug: "/coop/onboarding/4" }
    ],
    []
  );

  const getActiveStepIndex = (pathname: string | null) => {
    if (!pathname) return -1;
    if (pathname.includes("/coop/onboarding/2a")) {
      return 1;
    }

    const index = steps.findIndex(step => {
      return step.slug.includes(pathname);
    });

    return index;
  };

  if (!pathname?.includes("onboarding")) return null;

  return (
    <div className="flex gap-8 text-coinage-body pt-6 tab:pt-0 w-full justify-center">
      {steps.map(step => {
        const activeStepIndex = getActiveStepIndex(pathname);
        const isPastStep = step.id < activeStepIndex;
        const isActive = pathname.includes(step.slug);

        const className = cx("justify-center items-center gap-2", {
          "hidden tab:flex": !isActive,
          flex: isActive
        });
        return (
          <p key={step.id} className={className}>
            <span
              className={cx(
                {
                  "bg-coinage-orange text-coinage-offWhite border-coinage-orange":
                    isActive,
                  "border-current": !isActive,
                  "text-coinage-blue border-coinage-blue": isPastStep
                },
                "flex items-center justify-center rounded-full w-7 h-7 border-2 mono1"
              )}>
              {isPastStep ? <Tick width="15" /> : step.id + 1}
            </span>
            <span
              className={cx("btn", {
                "text-coinage-orange": isActive,
                "text-coinage-blue": isPastStep
              })}>
              {step.label}
            </span>
          </p>
        );
      })}
    </div>
  );
};
